export var QUBIC_API_KEY = process.env.NEXT_PUBLIC_QUBIC_API_KEY || "";
export var QUBIC_API_SECRET = process.env.NEXT_PUBLIC_QUBIC_API_SECRET || "";
export var QUBIC_CHAIN_ID = process.env.NEXT_PUBLIC_QUBIC_CHAIN_ID || "";
export var QUBIC_INFURA_PROJECT_ID = process.env.NEXT_PUBLIC_QUBIC_INFURA_PROJECT_ID || "";
export var IS_DEV = process.env.NODE_ENV === "development";
